import axios from 'axios';
import type { ReplayRunFromSourceSelection } from '@/types/runs.ts';
import { getHttpErrorMessage } from '@/services/httpRetry.ts';
export function getReplayRunFromSourceErrorMessage(
  error: unknown,
  selection: ReplayRunFromSourceSelection,
): string {
  if (axios.isAxiosError(error) && error.response?.status === 409 && selection === 'active')
    return 'The published selection changed or is unavailable. Refresh it and review before replaying.';
  return getHttpErrorMessage(error);
}
